﻿import 'promise-polyfill/src/polyfill';
import 'isomorphic-fetch';

import URLSearchParams from '@ungap/url-search-params';
import { getCookie } from './cookies';

export const apiPromise = (url, data, lang = null, requestMethod = 'GET') => {
  if (lang && lang.length > 2) {
    requestMethod = lang;
    lang = null;
  }
  const apiHeaders = new Headers();

  if (lang)
    apiHeaders.append('Override-Language', lang);

  const userHash = getCookie('__aimopark-user-hash');

  if(userHash)
    apiHeaders.append('Authorization', 'Bearer ' + userHash);

  const isFormData = data instanceof FormData;
  if (!isFormData) {
    apiHeaders.set('Content-Type', 'application/json');
  }   

  if (data && (requestMethod === 'GET' || requestMethod === 'HEAD'))
    url += (url.indexOf('?') === -1 ? '?' : '&') + new URLSearchParams(data).toString();

  return new Promise((resolve, reject) => {
    const apiRequest = new Request(url, {
      method: requestMethod,
      cache: 'no-cache',
      headers: apiHeaders,
      body: (requestMethod !== 'GET' && requestMethod !== 'HEAD') ? 
        (isFormData ? data : JSON.stringify(data))
        : null
    });

    fetch(apiRequest)
      .then(response => {
        if (!response)
          return;

        if(response.status === 401 || response.status === 403 || response.StatusCode === 401 || response.StatusCode === 403) {
          reject({status: response.StatusCode ?? response.status, info: 'Authentication error.', body: response });
        } else if(response.status === 404 || response.StatusCode === 404) {
          reject({status: response.StatusCode ?? response.status, info: 'Endpoint not found.', body: 'Requested URL: ' + url });
        } else if((response.status >= 500 && response.status < 600) || (response.StatusCode >= 500 && response.StatusCode < 600)) {
          reject({status: response.StatusCode ?? response.status, info: 'Internal server error.', body: 'Requested URL: ' + url });
        } else {
          return response.json()
        }
      })
      .then(response => {
        if (!response)
          return;

        resolve({ status: response.StatusCode ?? 200, info: 'OK', body: response.Data ?? response, errorMessage: response.ErrorMessage })
      }).catch((error) => {
        reject({ status: 400, info: 'Error.', body: error })
      });
  });
}

export const htmlPromise = (url, data, lang = null, requestMethod = 'GET') => {
  if (lang && lang.length > 2) {
    requestMethod = lang;
    lang = null;
  }
  const apiHeaders = new Headers();
  apiHeaders.append('Content-Type', 'application/json');

  if (lang)
    apiHeaders.append('Override-Language', lang);

  if (data && (requestMethod === 'GET' || requestMethod === 'HEAD'))
    url += (url.indexOf('?') === -1 ? '?' : '&') + new URLSearchParams(data).toString();

  return new Promise((resolve, reject) => {
    const apiRequest = new Request(url, {
      method: requestMethod,
      cache: 'no-cache',
      headers: apiHeaders,
      body: (requestMethod !== 'GET' && requestMethod !== 'HEAD') ? JSON.stringify(data) : null
    });

    fetch(apiRequest)
      .then(response => {
        if (response)
          return response.text();
        else
          reject({status: 500, info: 'Internal server error.', body: '' });
      }).then(html => {
          if(html && html.length > 0)
            resolve({ status: 200, body: html })
          else
            reject({status: 500, info: 'Internal server error.', body: '' });
      }).catch((error) => {
        reject({status: 500, info: 'Internal server error.', body: '' });
      });
  });
}
